
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/2023-mui-values",
      function () {
        return require("private-next-pages/blog/2023-mui-values.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/2023-mui-values"])
      });
    }
  